import React from "react";
import { Autocomplete, Box, Button, Grid, Paper, Stack, TextField, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Icon } from "@iconify/react/dist/iconify.js";
const CalendarBoxDesign = React.memo(({ item, boxClickFunction, singleDayAttendancViewFuction }) => {
  const backgroundColor =
    !item.trainerAttendanceID && item.rescheduled_id //NO TRAINER ID AND PRESENCE OF RESCHEDULED ID MEANS THE OBJECT IS RESCHEDULED SO MAKE THE COLOR TO YELLOW
      ? "#fce9034a"
      : item.trainerAttendanceID // IF TRAINER ID IS PRESENT THEN MAKE THE COLOR TO GREEN ELSE BLUE
      ? "#41fc032e"
      : item.reschedule_requested_by == 1 && !item.rescheduled_at
      ? "#ff00004d"
      : "#03a9fc2e";
  return (
    // <motion.div
    //   key={item.id} // Ensures animation runs only once per unique item
    //   initial={!hasAnimated ? { rotateY: 180 } : false} // Only animate initially
    //   animate={!hasAnimated ? { rotateY: 0 } : false} // Stop animation after first render
    //   transition={{ duration: 0.5 }}
    //   style={{ perspective: "1000px" }}
    //   onAnimationComplete={() => setHasAnimated(true)} // Set flag after first animation
    // >
    <>
      <Paper
        {...(item.rescheduled_id ? { onClick: () => boxClickFunction(item) } : {})}
        elevation={3}
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: backgroundColor,
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          minHeight: "150px",
          transition: "transform 0.3s ease, border 0.3s ease",
          "&:hover": {
            border: item.rescheduled_id ? "0.5px solid black" : "",
            transform: item.rescheduled_id ? "scale(1.05)" : "",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100px",
            height: "30px",
            bgcolor:
              !item.trainerAttendanceID && item.rescheduled_id //SIDE BANNER COLOR MAKING TO DARK TO SHOW COMPLETED, PENDING, RESCHEDULED
                ? "#fce903" //YELLOW RESCHEDULED
                : item.trainerAttendanceID
                ? "#41fc0378" //GREEN DONE
                : item.reschedule_requested_by == 1 && !item.rescheduled_at
                ? "RED"
                : "#03a9fc75", //PENDING BLUE
            color: "white",
            fontSize: "8px",
            fontWeight: "bold",
            textAlign: "center",
            transform: "rotate(-45deg) translate(-20px, -10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingRight: "7px",
          }}
        >
          {!item.trainerAttendanceID && item.rescheduled_id
            ? "RESCHEDULED"
            : item.trainerAttendanceID
            ? "COMPLETED"
            : item.reschedule_requested_by == 1 && !item.rescheduled_at
            ? "RESCHEDULE REQUESTED"
            : "PENDING"}
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            cursor: "pointer",
          }}
        >
          {item?.trainerAttendanceID && ( //TOOLTIP TO SHOW THE SESSION DETAILS ON HOVER,DATA IS AVAILBALE ONLY FOR COMPLETED SESSIONS
            <Box>
              <Tooltip
                title={
                  <Box
                    sx={{
                      bgcolor: "white",
                      color: "black",
                      p: 1,
                      borderRadius: "4px",
                      boxShadow: 3,
                      minWidth: "120px",
                    }}
                  >
                    <Typography variant="body2">
                      <strong>Chapter : </strong>
                      {item.academic_calendar_data?.chapter}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Topic : </strong>
                      {item.academic_calendar_data?.topic}
                    </Typography>
                    <Typography variant="body2">
                      <strong> Objectives : </strong>
                      {item.academic_calendar_data?.objectives}
                    </Typography>
                  </Box>
                }
                arrow
              >
                {item?.academic_calendar_data?.session_no && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Icon icon="mdi:eye" width="20" height="20" />
                  </Box>
                )}
              </Tooltip>
              <Box mt={1} onClick={() => singleDayAttendancViewFuction(item)}>
                <Icon icon="mdi:account-student" width="20" height="20" />
              </Box>
            </Box>
          )}
        </Box>

        <Typography mt={1} fontWeight="bold" color="primary">
          {dayjs(item.session_date).format("YYYY ddd, MMM D")}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {dayjs(item.from_time, "HH:mm:ss").format("hh:mm A")} - {dayjs(item.to_time, "HH:mm:ss").format("hh:mm A")}
        </Typography>

        <Stack gap={0}>
          <Typography variant="button" color="textSecondary">
            {item.subject_name} {item.session_no ? ` - Session ${item.session_no}` : ""}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {`Lesson - ${item?.id}`}
          </Typography>
        </Stack>

        {item?.type && (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Typography
              variant="caption"
              color={item?.type?.toLowerCase().includes("exam") ? "#df4d51" : "#63738c"}
              sx={{
                fontStyle: "italic",
                fontWeight: "bold",
                // textShadow: '0.5px 0.5px 0 black'
              }}
            >
              {item?.type || "Class"}
            </Typography>
          </Box>
        )}
      </Paper>
    </>
  );
});

export default CalendarBoxDesign;
